module.exports = __webpack_public_path__ + "static/media/bg.76b546a6.jpg";